<template>
    <div id="app" class="project container">
        <div class="columns">
            <div class="column is-half" v-bind:class="{ reverse: !(index % 2 == 0) }">
                <div class="columns svg-divider-container">
                    <svg class="column svg-divider" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="-10 0 200 50" width="100" height="100"> <defs> <path d="M183.78 30.64C165.41 30.64 156.22 10.64 137.84 10.64C119.46 10.64 110.27 30.64 91.89 30.64C73.51 30.64 64.32 10.64 45.95 10.64C27.57 10.64 18.38 30.64 0 30.64" id="gEK2QeZAN"></path> </defs> <g> <g> <g> <use xlink:href="#gEK2QeZAN" opacity="1" fill="#000000" fill-opacity="0"></use> <g> <use xlink:href="#gEK2QeZAN" opacity="1" fill-opacity="0" :stroke="project.color" stroke-width="20" stroke-opacity="1"></use> </g> </g> </g> </g> </svg>
                </div>
                <span class="is-size-6 has-text-warning">
                    {{ project.date }}
                </span>
                <h2 class="title is-1 text-is-warning" :class="{'has-text-white': this.$root.$children[0].darkTheme}">
                    {{ project.name }}
                </h2>
                <h2 class="subtitle is-4 is-font-regular" :class="{'has-text-white-ter': this.$root.$children[0].darkTheme}" v-html="project.content"></h2>
                <div>
                    <span class="is-inline subtitle is-6" :class="{'has-text-white': this.$root.$children[0].darkTheme}">Techs: </span>
                    <div class="tags are-medium is-inline">
                        <span v-for="tech in project.techs" :key="tech">
                            <img :src="tech" width="32" style="margin:4px; margin-bottom: -10px"/>
                        </span>
                    </div><br><br>
                    <span class="is-inline subtitle is-6" :class="{'has-text-white': this.$root.$children[0].darkTheme}">Affiliation: </span>
                    <div class="tags are-medium is-inline">
                        <span class="tag is-dark" v-for="item in project.company" :key="item">
                            {{ item }}
                        </span>
                    </div><br>
                    <span class="is-inline subtitle is-6" :class="{'has-text-white': this.$root.$children[0].darkTheme}">Tags: </span>
                    <div class="tags are-medium is-inline">
                        <span class="tag is-light" v-for="tag in project.tags" :key="tag">
                            {{ tag }}
                        </span>
                    </div><br>
                    <span v-if="project.sources[0]" class="is-inline subtitle is-6" :class="{'has-text-white': this.$root.$children[0].darkTheme}">Source: </span>
                    <div class="tags are-large is-inline" v-if="project.sources[0]">
                        <span class="tag is-black " v-for="source in project.sources" :key="source">
                            <unicon name="github" fill="white" icon-style="monochrome" style="margin-top: 8px; margin-right: 8px"></unicon>
                            <a class="has-text-white" :href="source"> {{ Object.keys(source)[0] }}</a>
                        </span>
                    </div>
                </div>
            </div>
            <div class="column is-half">
                <!-- <img :src="project.image" /> -->
                <!-- <img v-for="image in project.images" :key="image" :src="image" /> -->
                <!-- <VueSlickCarousel 
                    :arrows="true" 
                    :dots="true"
                    :slidesToShow="2"
                    :rows="2"
                    :lazyLoad="ondemand"
                    >
                        <img v-for="(image, i) in project.images" :key="i" :src="image" />
                </VueSlickCarousel> -->
                <b-carousel :autoplay="false" indicator-custom :indicator-inside="false" :overlay="gallery" >
                    <b-carousel-item v-for="(item, i) in project.images" :key="i" >
                        <a class="image ">
                            <img :src="item" v-on:click="switchGallery(true)">
                        </a>
                    </b-carousel-item>
                    <span v-if="gallery" v-on:click="switchGallery(false)" class="modal-close is-large"/>
                    <template #indicators="props">
                        <figure class="al image" :draggable="false">
                            <img :draggable="false" :src="getImgUrl(props.i)">
                        </figure>
                    </template>
                </b-carousel>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    project: Object,
    index: Number
  },
  data() {
    return {
        gallery: false
    }
  },
  methods: {
    getImgUrl(value) {
        let images = [];
        images = this.project.images;
        return images[value];
    },
    switchGallery(value) {
        this.gallery = value;
        if (value) {
            return document.documentElement.classList.add('is-clipped')

        } else {
            return document.documentElement.classList.remove('is-clipped')
        }
    }
  }
}
</script>

<style lang="scss" scoped>
h2.title {
    font-weight: bold;
}

.svg-divider {
    position: relative;
    top: 30px;
    left: -5px;
    zoom: 1.3;
    height: 82px;
    width: 100px;
}

.project {
    position: relative;
}

@media only screen and (min-width: 770px) {
    .reverse {
        order: 1;
    }
    .project > .columns {
        margin-top: 100px;
    }
    .svg-divider {
        // display: none;
        margin-top: -45px;
        left: -3px;
        height: 42px;
        width: 10px;
        float: left;
    }

    .svg-divider-container {
        position: relative;
        left: calc(-50% + 49px);
        top: -20px;
    }
}
</style>

<style lang="scss">
.is-font-regular * {
    font-weight: normal;
    font-family: "AvertaStd-Regular", sans-serif !important;
}
.is-font-bold * {
    font-family: "AvertaStd-Bold", sans-serif !important;
}
</style>
<style scoped>
.is-active .al img {
    border: 1px solid #fff;
    filter: grayscale(0%);
}
.al img {
    border: 1px solid transparent;
    filter: grayscale(100%);
}
</style>